import { render, staticRenderFns } from "./MenuSetting.vue?vue&type=template&id=3f6a0524&scoped=true&lang=pug&"
import script from "./MenuSetting.vue?vue&type=script&lang=js&"
export * from "./MenuSetting.vue?vue&type=script&lang=js&"
import style0 from "./MenuSetting.vue?vue&type=style&index=0&id=3f6a0524&scoped=true&lang=stylus&"
import style1 from "./MenuSetting.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6a0524",
  null
  
)

export default component.exports